import { useSelector } from "react-redux"

export const useSiteVersion = () => {
  const { settings } = useSelector(state => ({
    settings: state.Settings.settings,
  }))
  const version = {
    isBasic: false,
    isPremium: true,
    isAdvanced: false,
    currentVersion: "premium",
  }
  if (settings?.setup?.version === "basic") {
    return {
      ...version,
      isBasic: true,
      currentVersion: "basic",
    }
  } else if (settings?.setup?.version === "premium") {
    return {
      ...version,
      isPremium: true,
      currentVersion: "premium",
    }
  } else if (settings?.setup?.version === "advanced") {
    return {
      ...version,
      // isAdvanced: true,
      // currentVersion: "advanced",
      isPremium: true,
      currentVersion: "premium",
    }
  }
  return version
}
